export default {
    ip: null,
    ipLocationDetails: null,
    form: {},
    copyData: {},
    dynamicInputValuesModified: null,
    configData: {},
    warning: null,
    useOcr: false,
    restrictDuplicateCustomers: false,
    isIndustrial: true,
    isTaxIdRequired: false,
    isTaxIdMandatory: false,
    taxIdNote: null,
    idDocumentExpiryNote: null,
    cardTypeOverride:null,
    ocrStatusFront:null,
    ocrStatusBack:null,
    addressProofDocumentType:null,
    isShowGuide:false,
    filteredMenu: [],
    ocrFieldFlags: {},
    ocrFieldFileNames: {},
    journeyInitialized: false,
    skipOcrForDocumentLoad: false,
    /** Deep link: set true when OCR-eligible documents change → user must redo liveness */
    deepLinkOcrInvalidatedLiveness: false,
    disableNameEdit: false,
    pepCondition: false,
}
